import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ERROR } from '@coconut/constants/apiStatus';

import {
  actions,
  types,
  combineSubjectData,
} from '@coconut/services/redux/askQuestion';

import * as apis from '../apis/curriculum';

function* getNestedSubject({ subjects, subjectGroups }) {
  /*
    Try to find subject group from subject.subject_group_ids, and
    if it has it's own group, make subject group as first layer.
  */
  const subjectGroupForCurrentRegion = [];
  let subjectsWithoutGroup = subjects.slice(0);

  subjectGroups.forEach((group) => {
    const childSubjects = subjects.filter((subject) => {
      const isChildSubject = subject.subject_group_ids.includes(group.id);
      if (isChildSubject) {
        // remove from the subject list if it has own group.
        subjectsWithoutGroup = subjectsWithoutGroup.filter(
          (s) => s.id !== subject.id
        );
      }

      return isChildSubject;
    });

    if (childSubjects.length) {
      subjectGroupForCurrentRegion.push({
        id: group.id,
        description: group.name,
        enable: true,
        childSubjects,
      });
    }
  });

  return [...subjectGroupForCurrentRegion, ...subjectsWithoutGroup];
}

function* getInitialCurriculumsAndSubjectsFlow() {
  try {
    const curriculumResponse = yield call(apis.getCurriculums);

    if (curriculumResponse.status === ERROR) {
      throw new Error(curriculumResponse.error_code);
    }

    const [defaultCurriculum] = curriculumResponse.data.curriculums.slice(0, 1);
    const curriculumId = defaultCurriculum.id;
    const subjectResponse = yield call(apis.getSubjects, curriculumId);
    const { subject_groups: subjectGroups, ...subjectList } =
      subjectResponse.data;
    const subjects = combineSubjectData(subjectList);
    const nestedSubjects = yield call(getNestedSubject, {
      subjects,
      subjectGroups,
    });

    yield put(
      actions.getInitialCurriculumsAndSubjectsSuccess({
        curriculums: curriculumResponse.data.curriculums,
        nestedSubjects,
        subjects,
      })
    );
  } catch (error) {
    yield put(actions.getInitialCurriculumsAndSubjectsFail());
  }
}

function* getSubjectsFlow(action) {
  try {
    const { curriculumId } = action;
    const subjectResponse = yield call(apis.getSubjects, curriculumId);
    const { subject_groups: subjectGroups, ...subjectList } =
      subjectResponse.data;
    const subjects = combineSubjectData(subjectList);
    const subjectData = yield call(getNestedSubject, {
      subjects,
      subjectGroups,
    });

    yield put(
      actions.getSubjectsSuccess({
        nestedSubjects: subjectData,
        subjects,
      })
    );
  } catch (error) {
    yield put(actions.getSubjectsFail());
  }
}

export default function* () {
  yield all([
    takeLatest(
      types.GET_INIT_CURRICULUMS_AND_SUBJECTS_REQUEST,
      getInitialCurriculumsAndSubjectsFlow
    ),
    takeLatest(types.GET_SUBJECTS_REQUEST, getSubjectsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/askQuestion.js